"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./components/Dialog/index'));
var index_2 = require('./components/Dialog/index');
exports.default = index_2.Dialog;

//# sourceMappingURL=Dialog.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./Dialog.js
 ** module id = 151
 ** module chunks = 0
 **/